import { makeCygnusApiCall } from "api/api";

export const getParentReturnIds = async (
  clientMasterId: any,
  parentMasterId: any,
): Promise<any[]> => {
  if (!clientMasterId || !parentMasterId) return [];

  const returnIds = await makeCygnusApiCall({
    type: "GET",
    url: `/internalk1/returns/parent/${clientMasterId}/${parentMasterId}/`,
    show_message: false,
    customized_success_message: "Fetched Data Successfully",
    customized_failure_message: "Unable to fetch destination return IDs, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true,
  });

  return returnIds?.data ?? [];
};
